import store from '@/store'
import request from '@/api/axioRequest.js'
import _ from 'lodash'

export default {
  getCrm () {
    return request.get('crm_connections/get/')
      .then(response => {
        store.commit('data/updateCrm', response)
        return response
      })
  },
  deleteCrm (sfdcConnectionId) {
    return request.post('crm_connections/delete/', { 'crm_connection_id': sfdcConnectionId })
  },
  salesforceFields (data) {
    return request.get(`salesforce/getfields/?crm_connection_id=${data.connection_id}&object=${data.object}`)
      .then(response => {
        if (response.error) {
          return response
        } else {
          response = _.sortBy(response, [function (a) { return a.name }])
          return { 'response': response, 'object': data.object }
        }
      })
  },
  sfObject (connectionId, all = false) {
    if (all) {
      return request.get(`salesforce/getobjects/?crm_connection_id=${connectionId}&all='all'`)
    } else {
      return request.get(`salesforce/getobjects/?crm_connection_id=${connectionId}`)
    }
  },
  getSfRecords (data) {
    return request.get(`salesforce/getrecordssample/?crm_connection_id=${data.crm_connection_id}&object=${data.sfObject}`)
  },
  getCustomerAttributes (sfdcConnectionId) {
    return request.get(`attributes/get/?crm_connection_id=${sfdcConnectionId}`)
      .then(response => {
        var attributes = response.attributes
        response.attributes = _.sortBy(attributes, [function (a) { return a.field }])
        return response
      })
  },
  SaveCustomerAttributes (data) {
    return request.post('attributes/save/', data)
  },
  postVistitorId (data) {
    return request.post('visitoridmapping/', data)
  },
  getVistitorId (crmConnectionId) {
    return request.get(`visitorid/getmapping/?crm_connection_id=${crmConnectionId}`)
  },
  getDynamicsObject (connectionId, all = false) {
    if (all) {
      return request.get(`dynamics/getobjects/?connection_id=${connectionId}&all='all'`)
    } else {
      return request.get(`dynamics/getobjects/?connection_id=${connectionId}`)
    }
  },
  getDynamicsFields (object, connectionId) {
    return request.get(`dynamics/getfields/?object=${object}&connection_id=${connectionId}`)
      .then(response => {
        if (response.error) {
          return response
        } else {
          var fields = response.field
          fields = _.sortBy(fields, [function (a) { return a.name }])
          return { 'fields': fields, 'entity': response.entity }
        }
      })
  },
  getDynamicsRecords (object, connectionId) {
    return request.get(`dynamics/getrecords/?object=${object}&connection_id=${connectionId}`)
      .then(response => {
        return response
      })
  }
}
